import React, { useCallback } from 'react'
import styled from 'styled-components'
import { LabelContainer } from './style'

function CheckboxComponent({ label, model, onChange, value, ...rest }) {
    const change = useCallback(e => {
        if(onChange) {
            onChange(e)
        }

        if(model) {
            model.onChange(e)
        }
    })

    return (
        <LabelContainer pointer>
            <Checkbox
                type='checkbox'
                name={model ? model.name : ""}
                checked={model ? model.value : undefined}
                onChange={change}
                {...rest} />
            <i></i>
            <Label>{label}</Label>
        </LabelContainer>
    )
}

const Checkbox = styled.input`
    opacity: 0;
    position: absolute;

    + i {
        display: block;
        float: left;
        width: 16px;
        height: 16px;
        border: 1px solid #E8E8E8;
        border-radius: 3px;
        margin-right: 1rem;
        position: relative;

        &::before {
            content: ' ';
            display: block;
            width: 10px;
            height: 10px; 
            background-color: #f5f5f5;
            border-radius: 2px;
            position: absolute;
            top: 2px;
            left: 2px;
        }
    }

    &:checked + i::before {
        background-color: #f50;
    }
`

const Label = styled.span`
    font-size: 1.2rem;
    color: #707070;
`


export default CheckboxComponent



// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/Checkbox.js